// Chakra imports
import {
  Box,
  Flex,
  Text,
  Icon,
  useColorModeValue,
  Checkbox,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/Dashboard/card/Card";
import Menu from "../../../../components/Dashboard/menu/MainMenu";
import IconBox from "../../../../components/Dashboard/icons/IconBox";

// Assets
import { MdCheckBox, MdDragIndicator } from "react-icons/md";
import React from "react";

export default function Conversion(props) {
  const { ...rest } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "blackAlpha.900");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "blackAlpha.900");
  const boxBg = useColorModeValue("secondaryGray.300", "blackAlpha.900");
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const cardBg = useColorModeValue("white",  'linear-gradient(135deg, #ffdeefff 0%, #ffcbe4ff 50%, #ffd2e6ff 100%)');

  return (
    <Card
      p="20px"
      align="center"
      direction="column"
      w="100%"
      bg={cardBg}        // 🔹 card background adapts to mode
      {...rest}
    >
      <Flex alignItems="center" w="100%" mb="30px">
        <IconBox
          me="12px"
          w="38px"
          h="38px"
          bg={boxBg}
          icon={<Icon as={MdCheckBox} color={brandColor} w="24px" h="24px" />}
        />

        <Text color={textColor} fontSize="lg" fontWeight="700">
          Tasks
        </Text>
        <Menu ms="auto" />
      </Flex>

      <Box px="11px">
        <Flex mb="20px">
          <Checkbox me="16px" colorScheme="brandScheme" />
          <Text
            fontWeight="bold"
            color={textColor}
            fontSize="md"
            textAlign="start"
          >
            Landing Page Design
          </Text>
          <Icon
            ms="auto"
            as={MdDragIndicator}
            color={textColorSecondary}   // 🔹 adapts in dark mode
            w="24px"
            h="24px"
          />
        </Flex>

        <Flex mb="20px">
          <Checkbox me="16px" defaultChecked colorScheme="brandScheme" />
          <Text
            fontWeight="bold"
            color={textColor}
            fontSize="md"
            textAlign="start"
          >
            Dashboard Builder
          </Text>
          <Icon
            ms="auto"
            as={MdDragIndicator}
            color={textColorSecondary}
            w="24px"
            h="24px"
          />
        </Flex>

        <Flex mb="20px">
          <Checkbox defaultChecked me="16px" colorScheme="brandScheme" />
          <Text
            fontWeight="bold"
            color={textColor}
            fontSize="md"
            textAlign="start"
          >
            Mobile App Design
          </Text>
          <Icon
            ms="auto"
            as={MdDragIndicator}
            color={textColorSecondary}
            w="24px"
            h="24px"
          />
        </Flex>

        <Flex mb="20px">
          <Checkbox me="16px" colorScheme="brandScheme" />
          <Text
            fontWeight="bold"
            color={textColor}
            fontSize="md"
            textAlign="start"
          >
            Illustrations
          </Text>
          <Icon
            ms="auto"
            as={MdDragIndicator}
            color={textColorSecondary}
            w="24px"
            h="24px"
          />
        </Flex>

        <Flex mb="20px">
          <Checkbox defaultChecked me="16px" colorScheme="brandScheme" />
          <Text
            fontWeight="bold"
            color={textColor}
            fontSize="md"
            textAlign="start"
          >
            Promotional LP
          </Text>
          <Icon
            ms="auto"
            as={MdDragIndicator}
            color={textColorSecondary}
            w="24px"
            h="24px"
          />
        </Flex>
      </Box>
    </Card>
  );
}
